// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cc-acl-subject {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cc-acl-subject__avatar {
  flex-shrink: 0;
}
.cc-acl-subject__info {
  min-width: 0;
  flex: 1;
}
.cc-acl-subject__info-name {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cc-acl-subject__info-meta {
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
  color: var(--g-color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cc-acl-subject .yc-user-avatar_size_m {
  width: 32px;
  height: 32px;
}
.cc-acl-subject .yc-user-avatar__avatar {
  width: 32px;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AclSubject/AclSubject.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACI,cAAA;AACR;AAEI;EACI,YAAA;EACA,OAAA;AAAR;AAGI;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAII;EACI,yCAAA;EACA,6CAAA;EACA,oCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFR;AAMQ;EACI,WAAA;EACA,YAAA;AAJZ;AAOQ;EACI,WAAA;EACA,YAAA;AALZ","sourcesContent":[".cc-acl-subject {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.cc-acl-subject__avatar {\n  flex-shrink: 0;\n}\n.cc-acl-subject__info {\n  min-width: 0;\n  flex: 1;\n}\n.cc-acl-subject__info-name {\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.cc-acl-subject__info-meta {\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n  color: var(--g-color-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.cc-acl-subject .yc-user-avatar_size_m {\n  width: 32px;\n  height: 32px;\n}\n.cc-acl-subject .yc-user-avatar__avatar {\n  width: 32px;\n  height: 32px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
